import React, { useState } from 'react';
import Popover from '@material-ui/core/Popover';
import Typography from '@material-ui/core/Typography';
import { Button, Grid, makeStyles } from '@material-ui/core';
import JsonTableEditor from '../jsonFormEditor/JsonTableEditor';


const demoData = [
    {
        label: "Option1",
        value: "value1"
    },
    {
        label: "Option2",
        value: "value2"
    },
    {
        label: "Option3",
        value: "value3"
    },
    {
        label: "Option4",
        value: "value4"
    }

]

const useStyles = makeStyles((theme) => ({
    popoverPaper: {
      width: 500,
      maxWidth: 500,
      overflowX: 'hidden',
      overflowY: 'auto',
      maxHeight: '70vh',
      borderRadius: 8,
      padding: theme.spacing(2),
    },
    dropdownContainer: {
      width: '100%',
    },
    dropdownHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      paddingBottom: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
    dropdownTitle: {
      fontSize: '16px',
      fontWeight: 600,
    },
    editorWrapper: {
      '& input': {
        height: 32,
        fontSize: 14,
        padding: '4px 8px',
      },
      '& td': {
        padding: '4px 6px',
        verticalAlign: 'middle',
      },
      '& button': {
        minWidth: 28,
        minHeight: 28,
        marginLeft: 4,
      },
    },
    dropdownFooter: {
      display: 'flex',
      justifyContent: 'flex-end',
      marginTop: theme.spacing(2),
    },
    okButton: {
      textTransform: "none",
      padding: '6px 16px',
      fontSize: 14,
      borderRadius: 6,
    },
  }));



function DropdownOptions({field_id, anchorEl, setAnchorEl, position, updateSchemaWithAttribute, dropdownSchema }) {

    const classes = useStyles();

    const [schemaValues, setSchemaValues] = useState({ options: dropdownSchema });
    const [dropdownData, setDropdownData] = useState([]);
    const [selectedField, setSelectedField] = useState(field_id);

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? `simple-popover-${field_id}` : undefined;

    let options = {
        form_name_root: "dropdown_options",
        show_errors: "never",
        disable_collapse: true,
        disable_edit_json: true,
        disable_properties: true,
        remove_button_labels: true,
        input_width: '60px',
        disable_array_delete_all_rows: true,
        disable_array_reorder: true,
    }

    const schema = {
        type: "object",
        no_additional_properties: true,
        properties: {
            options: {
                type: "array",
                format: "table",
                items: {
                    type: "object",
                    title: "Option",
                    properties: {
                        label: {
                            type: "string",
                            title: "Label",
                        },
                        value: {
                            type: "string",
                            title: "Value",
                        },

                    },
                },
                default: []
            }
        }
    };

    const validation = (schema, value, path) => {
        var errors = [];
        return errors;
    };

    const onChangeJsonEditor = (data) => {
        const elementToDisable = document.querySelectorAll('.card-title');
        if (elementToDisable) {
            elementToDisable.forEach(element => {
                element.style.display = 'none';
            });
        }

        const options = data.options?.filter(item => item?.label != "");

        setDropdownData(options || []);
    }

    const updateTable = () => {
        updateSchemaWithAttribute({rowId: selectedField, attribute: 'constraint', action: 'add', value: dropdownData});
        handleClose();
    }


    return (
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
                anchorReference="anchorPosition" // Enable manual positioning
                anchorPosition={position} // Set custom X, Y position
                // PaperProps={{
                //     style: {
                //         width: "400px", // set fixed width
                //         maxWidth: "400px", // prevents growing sideways
                //         overflowX: "hidden", // disable horizontal scrollbars
                //         overflowY: "auto",   // enable vertical scrolling if too tall
                //         maxHeight: "70vh"    // optional: cap height to viewport
                //     }
                // }}
                classes={{ paper: classes.popoverPaper }}
            >
                <Grid container spacing={3} className={`dropdown_container ${classes.dropdownContainer}`} >
                    <Grid item xs={12} className={`dropdown_header ${classes.dropdown_header}`}>
                        <Typography variant="h5" className={classes.dropdownTitle} >Dropdown Options</Typography> 
                        {/* <CloseIcon className={"dropdown_close"} /> */}
                    </Grid>
                    <Grid item xs={12} style={{paddingTop: '0', paddingBottom: '0'}} className={classes.editorWrapper}>
                        <JsonTableEditor options={options} schema={schema} schemaValues={schemaValues} validation={validation} onChangeJsonEditor={onChangeJsonEditor} editorId="json_table_editor" />
                    </Grid>

                    <Grid item xs={12}  className={`dropdown_footer ${classes.dropdownFooter}`}>
                        <Button  variant="contained" id="update_option_button" color="primary" onClick={updateTable} className={classes.okButton}>Okay</Button>
                    </Grid>
                </Grid>
            </Popover>

    )
}

export default DropdownOptions